module.exports = __webpack_public_path__ + "img/add_book_cover.c466cf5d.svg";